import { AI_MAP_TASK_CLASSES, AI_MAP_TASK_OUTCOMES } from './ai-map-result.js';

export const AI_MAP_INTENT_VALUES = new Set(['add', 'change', 'remove', 'replace', 'move', 'unknown']);
export const AI_MAP_USEFUL_OUTCOME_VALUES = new Set(['export', 'share', 'save']);
export const AI_MAP_RESULT_FEEDBACK_VALUES = new Set(['correct', 'wrong_place', 'wrong_shape', 'incomplete']);
export const AI_MAP_PERFORMANCE_OUTCOME_VALUES = new Set(['applied', 'no_change', 'error']);
export const AI_MAP_DURATION_MS_ALLOWLIST = /^[0-9]{1,7}$/;
export const AI_MAP_MEASUREMENT_PROPS = {
  measurement_version: new Set(['2']), task_outcome: new Set(AI_MAP_TASK_OUTCOMES), task_class: new Set(AI_MAP_TASK_CLASSES),
  model_ms: AI_MAP_DURATION_MS_ALLOWLIST, tool_ms: AI_MAP_DURATION_MS_ALLOWLIST, verification_ms: AI_MAP_DURATION_MS_ALLOWLIST,
};
